// extracted by mini-css-extract-plugin
var _1 = "QGlqhgYJGfnhNk25Lo_t";
var _2 = "OPKhppD3OXx2lUILheeQ";
export { _1 as "inner", _2 as "root" }
